export enum GrowingProcessTypeEnum {
  FATTENING_TANKS = 'fatteningtanks',
  FATTENING_PONDS = 'fatteningponds',
  FATTENING_PENS = 'fatteningpens',
}
